/** Legacy device-local key — migrated to profile.heightCm on first Weigh In. */
export const LEGACY_SCALE_PROFILE_HEIGHT_STORAGE_KEY = '@abbisway/scaleProfileHeightCm';
export const MIN_PROFILE_HEIGHT_CM = 100;
export const MAX_PROFILE_HEIGHT_CM = 250;
/** Placeholder hint for US imperial height entry (single field). */
export const HEIGHT_DISPLAY_PLACEHOLDER = "5'10";
export function isValidProfileHeightCm(cm) {
    return (Number.isFinite(cm) &&
        cm >= MIN_PROFILE_HEIGHT_CM &&
        cm <= MAX_PROFILE_HEIGHT_CM);
}
export function feetInchesToCm(feet, inches) {
    const totalInches = feet * 12 + inches;
    return Math.round(totalInches * 2.54);
}
export function cmToFeetInches(cm) {
    const totalInches = cm / 2.54;
    let feet = Math.floor(totalInches / 12);
    let inches = Math.round(totalInches - feet * 12);
    if (inches === 12) {
        feet += 1;
        inches = 0;
    }
    return { feet, inches };
}
/** Compact US display: `5'10` (one field; metric can reuse the same slot later). */
export function formatHeightDisplay(cm) {
    const { feet, inches } = cmToFeetInches(cm);
    return `${feet}'${inches}`;
}
/** @deprecated Use formatHeightDisplay — kept for callers expecting spaced inches mark. */
export function formatHeightFeetInches(cm) {
    return formatHeightDisplay(cm);
}
/** Normalize iOS Smart Punctuation and other apostrophe-like chars to ASCII `'` / `"`. */
export function normalizeHeightDisplayInput(raw) {
    return raw
        .replace(/[\u2018\u2019\u201A\u2032\u02BC\u0060\u00B4]/g, "'")
        .replace(/[\u201C\u201D\u2033]/g, '"');
}
/**
 * Parses a single height field: `5'10`, `5'10"`, `5' 10`, feet-only `6'`.
 * Accepts curly apostrophes from iOS Smart Punctuation (e.g. `5'11`).
 * Returns canonical cm or null when unparseable / out of range.
 */
export function parseHeightDisplay(raw) {
    const trimmed = normalizeHeightDisplayInput(raw.trim());
    if (!trimmed) {
        return null;
    }
    const feetInches = trimmed.match(/^(\d+)\s*['′]\s*(\d+(?:\.\d+)?)\s*"?\s*$/);
    if (feetInches) {
        const feet = Number.parseInt(feetInches[1], 10);
        const inches = Number.parseFloat(feetInches[2]);
        if (Number.isFinite(feet) &&
            Number.isFinite(inches) &&
            inches >= 0 &&
            inches < 12) {
            const cm = feetInchesToCm(feet, inches);
            return isValidProfileHeightCm(cm) ? cm : null;
        }
        return null;
    }
    const feetOnly = trimmed.match(/^(\d+)\s*['′]\s*"?\s*$/);
    if (feetOnly) {
        const feet = Number.parseInt(feetOnly[1], 10);
        if (Number.isFinite(feet)) {
            const cm = feetInchesToCm(feet, 0);
            return isValidProfileHeightCm(cm) ? cm : null;
        }
    }
    return null;
}
export function parseLegacyStoredHeightCm(stored) {
    if (stored == null) {
        return undefined;
    }
    const cm = Number.parseInt(stored, 10);
    if (!isValidProfileHeightCm(cm)) {
        return undefined;
    }
    return cm;
}
export function initialHeightFormValues(profile) {
    if (profile?.heightCm != null && isValidProfileHeightCm(profile.heightCm)) {
        return { heightDisplay: formatHeightDisplay(profile.heightCm) };
    }
    return { heightDisplay: '' };
}
